module.exports = __webpack_public_path__ + "img/s03_p01.bd2aca7e.jpg";